import React, { useState } from 'react';
import { Form, Input, Button, Card, Alert, Space, Select, theme } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../../images/logo.png';
import './Login.css';

const { useToken } = theme;

const Login = () => {
  const { user, login, getDefaultRoute } = useAuth();
  const { token } = useToken();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();

  if (user) {
    return <Navigate to={getDefaultRoute()} replace />;
  }

  const handleSubmit = async (values) => {
    setLoading(true);
    setError('');

    const result = await login(values.username, values.password);

    setLoading(false);

    if (!result.success) {
      setError(result.error || t('auth.loginFailed'));
    }
  };

  return (
    <div className="login-container">
      <div style={{ position: 'absolute', top: 16, right: 16 }}>
        <Select
          value={i18n.language}
          onChange={(lang) => i18n.changeLanguage(lang)}
          size="small"
          options={[
            { value: 'ro', label: 'RO' },
            { value: 'en', label: 'EN' },
          ]}
          style={{ width: 65 }}
          data-testid="language-switcher"
        />
      </div>
      <Card className="login-card">
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div style={{ textAlign: 'center' }}>
            <img
              src={logo}
              alt="Clinica Olariu Med"
              className="login-logo-img"
            />
          </div>

          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              closable
              onClose={() => setError('')}
            />
          )}

          <Form
            name="login"
            onFinish={handleSubmit}
            autoComplete="off"
            layout="vertical"
            requiredMark={false}
          >
            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  message: t('auth.usernameRequired'),
                },
              ]}
            >
              <Input
                prefix={<UserOutlined style={{ color: token.colorTextSecondary }} />}
                placeholder={t('auth.usernamePlaceholder')}
                size="large"
                autoFocus
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: t('auth.passwordRequired'),
                },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: token.colorTextSecondary }} />}
                placeholder={t('auth.passwordPlaceholder')}
                size="large"
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 16 }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
                size="large"
                style={{ height: 48, fontSize: 16 }}
              >
                {t('auth.signIn')}
              </Button>
            </Form.Item>
          </Form>

        </Space>
      </Card>
    </div>
  );
};

export default Login;
